declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, MisReportRequest, MisReportXYController } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { Chart } from 'chart.js';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
//import { PlotlyModule } from 'angular-plotly.js';
import * as Plotly from 'plotly.js';
import { NgbGraphTableViewModal } from '../../consumptionentry/graphtableview.modal';
@Component({
    selector: 'horizontalbargraph',
    templateUrl: './horizontalbargraph.component.html',
    styleUrls: ['./horizontalbargraph.component.scss'],
    animations: [routerTransition()]
})

export class HorizontalBarGraphComponent implements OnInit, OnChanges {
    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        if (this.CanLoadReport) {
            //alert('loading graph...' + this.ReportType);
            //this.CanLoadReport = false;
            //  this.LoadData(this.ReportType, this.FromDate, this.ToDate);

        }
        // alert("XY BAR GRAPH :=> " + this.FromDate);

    }

    @Input() CanLoadReport: boolean = false;
    //Variable Declaration
    currentPage: string = "About"
    public isRequesting: boolean = false;

    //CurrentFdActorReportsDocController: FdActorReportsDocController[];
    //CurrentFDActorDocRequest: FDActorDocRequest;
    public ApiResData: ApiResponseModel;
    public chartType: string = 'line';
    ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
    ValueChangeActorImageController: ActorImageController;
    @Input() ReportType: string;
    @Input() FromDate: Date;
    @Input() ToDate: Date;
    @Input() FacilityCode: number;
    @Input() FacilityName: string;
    @Input() NurseActorCode: number = 0;
    @Input() ActorCode: number;
    @Input() CycleCode: number;
    @Input() Duration: number;
    @Input() FormattedCode: number;
    @Input() DisplayName: string;
    searchTitle: string;
    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;
    SelectedFromDate: NgbDateStruct;
    //
    //public FormattedCode: number = 0;
    public IsSetAccessRights: boolean;
    public CanEditProfileInfo: number = 0;
    public CanEditContactInfo: number = 0;
    public CanShowProfileInfo: number = 0;
    public CanShowContactInfo: number = 0;
    public Code: string;
    public PatientActorCode: number;
    public PatientCycleCode: number;
    public isGraphLoading: boolean = false;
    public CanShowProfileSummary: number = 0;
    public CanEditProfileSummary: number = 0;

    public CanShowJobPreferences: number = 0;
    public CanEditJobPreferences: number = 0;

    public CanShowEducation: number = 0;
    public CanEditEducation: number = 0;

    public CanShowEmploymentHistory: number = 0;
    public CanEditEmploymentHistory: number = 0;

    public CanShowReferences: number = 0;
    public CanEditReferences: number = 0;

    public CanShowIdentities: number = 0;
    public CanEditIdentities: number = 0;

    public CanShowCertifications: number = 0;
    public CanEditCertifications: number = 0;

    public CanShowMedicalFitness: number = 0;
    public CanEditMedicalFitness: number = 0;

    public CanShowProfileImage: number = 0;
    public CanEditProfileImage: number = 0;

    public CanShowLegalinfo: number = 0;
    public CanEditLegalinfo: number = 0;
    public showprofile: boolean = true;
    public showmessages: boolean = false;
    public ScanDetails: boolean = false;
    public Showpickup: boolean = true;
    public Showivf: boolean = false;
    //

    MisReportXYControllerData: MisReportXYController[];



    public SelectedReport: string;
    public SelectedActorCode: number = 92;







    constructor(private router: Router,
        private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
        private modalService: NgbModal,

    ) {

        //stepObject.init();
        //webGlObject.init();
    }
    bInit: boolean = false;
    misreq: MisReportRequest;
    LoadData(reportType: string, fromDate: Date, toDate: Date, facilitycode: number) {
        if (this.bInit) {
            var req = new MisReportRequest();
            req.ConditionalOperator = 10;
            req.ReportName = reportType;
            req.FromDate = fromDate;
            req.ToDate = toDate;
            req.FacilityCode = facilitycode;
            req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
            this.misreq = req;
        }
        else {
            var req = new MisReportRequest();
            req.ConditionalOperator = 10;
            req.ReportName = reportType;
            req.FromDate = fromDate;
            req.ToDate = toDate;
            req.FacilityCode = facilitycode;
            req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
            this.GetMisReport_(req);


        }
        //

    }

    LoadOrRefresh() {
        this.LoadData(this.ReportType, this.FromDate, this.ToDate, this.FacilityCode);
        // this.GetMisReport_(this.misreq);
        this.bInit = true;
    }
    numData: number[];
    lData: string[];
    colors: string[];
    GetMisReport_(req: MisReportRequest) {
        this.StartRefreshing();
        this.isGraphLoading = true;

        this.actorservice.GetMisReportByType(req)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.MisReportXYControllerData = this.ApiResData.Result;

                    var labels = this.MisReportXYControllerData.reduce((accumalator, current) => {
                        if (!accumalator.some(item => item.Label === current.Label)) {


                            accumalator.push(current);
                        }
                        return accumalator;
                    }, []);
                    //alert(labels);
                    var gdata: Array<graphdata> = new Array<graphdata>()
                    for (var l in labels) {

                        var gd: graphdata = new graphdata(l)
                        var numData = this.MisReportXYControllerData.filter(function (v, i, a) {
                            return v.Label = l
                        }).map(function (data, index, array) {
                            return data.yValue;
                        });
                        this.numData = numData;
                        gd.data = numData;
                        gd.backgroundColor = '#FFA726';
                        gd.borderColor = '#FFA726';
                        gd.fill = false;
                        // this.numData = numData;

                        //this.lData = lData;

                        gdata.push(gd)
                        //this.CurrentGraphData = new Array<graphdata>();
                        //this.CurrentGraphData.forEach((v, i, d) => {
                        //    var item = new graphdata();
                        //    item.label = lData.forEach;
                        //    this.CurrentConsumpationData.push(item);
                        //});
  }
                    var colors = this.MisReportXYControllerData.map(function (data, index, array) {
                        var color = "rgb(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                            +
                            Math.floor(Math.random() * 255) + ")";
                        return color;// Math.floor((Math.random() * (index+1)) + 1);
                    });
                    this.colors = colors;
                    var lData = this.MisReportXYControllerData.map(function (data, index, array) {
                        return data.xName;
                    });

                    this.lData = lData;
                    this.LoadGraph_(gdata, lData, colors);
                    this.stopRefreshing();
                    this.isGraphLoading = false;


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                });
  }

    GetMisReport(req: MisReportRequest) {
        // alert('old ')
        this.StartRefreshing();

        this.isGraphLoading = true;

        this.actorservice.GetMisReportByType(req)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.MisReportXYControllerData = this.ApiResData.Result;




                    var numData = this.MisReportXYControllerData.map(function (data, index, array) {
                        return data.yValue;
                    });
                    this.numData = numData;
                    var lData = this.MisReportXYControllerData.map(function (data, index, array) {
                        return data.xName;
                    });
                    this.lData = lData;
                    var colors = this.MisReportXYControllerData.map(function (data, index, array) {
                        var color = "rgb(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                            +
                            Math.floor(Math.random() * 255) + ")";
                        return color;// Math.floor((Math.random() * (index+1)) + 1);
                    });
                    this.colors = colors;

                    this.LoadGraph(numData, lData, colors);
                    this.stopRefreshing();
                    this.isGraphLoading = false;

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //       alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        //     alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        //    alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        //   alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                });
  }
    changeBackground(n: MisReportXYController): string {
        // alert(name);
        var style: string = 'white';

        var ind = this.lData.findIndex(function (v, i, obj) {
            return v == n.xName;
        });
        // alert(this.colors[ind]);
        return this.colors[ind];

    }
    getBorderStyle(name: string): string {
        // alert(name);
        var style: string = ' border-left: 5px solid white;';

        var ind = this.lData.findIndex(function (v, i, obj) {
            return v == name;
        });
        // alert(this.colors[ind]);
        return '5px solid ' + this.colors[ind];

    }
    public chartColors: Array<any> = [
        {
            backgroundColor: 'rgba(105, 0, 132, .2)',
            borderColor: 'rgba(200, 99, 132, .7)',
            borderWidth: 2,
        },
        {
            backgroundColor: 'rgba(0, 137, 132, .2)',
            borderColor: 'rgba(0, 10, 130, .7)',
            borderWidth: 2,
        }
    ];
    public chartOptions: any = {
        responsive: true
    };
    public graph: any;
    public options: any;
    @Input()
    DisplayType: string;
    LoadGraph(numData: number[], lables: string[], colors: string[]) {
        this.StartRefreshing();
        this.isGraphLoading = true;
        this.graph = {
            // data: [
            //   { x: lables, y: numData, type: 'bar', mode: 'lines+points', marker: { color: 'red' } },
            //   { type: 'bar' },

            // ],
            //layout: { width:'100%' , height: 480, title: '', showlegend: false },

            labels: lables, //x axis
            datasets: [
                {

                    data: numData,
                    fill: false,
                    backgroundColor: '#FFA726',
                    borderColor: '#42A5F5'
                },
                {

                    data: numData,
                    fill: false,
                    backgroundColor: '#FFA726',
                    borderColor: '#42A5F5'
                }

            ]

        };
        this.options = {
            legend: {
                display: false
            }
        };

        this.stopRefreshing();
        this.isGraphLoading = false;
    }


    LoadGraph_(datasets: graphdata[], lables: string[], colors: string[]) {
        this.StartRefreshing();
        this.isGraphLoading = true;
        this.graph = {
            // data: [
            //   { x: lables, y: numData, type: 'bar', mode: 'lines+points', marker: { color: 'red' } },
            //   { type: 'bar' },

            // ],
            //layout: { width:'100%' , height: 480, title: '', showlegend: false },

            labels: lables,
            datasets: datasets

        };
        this.options = {
            legend: {
                display: false
            }
        };

        this.stopRefreshing();
        this.isGraphLoading = false;
    }
    //LoadGraph(numData: number[], lables: string[], colors: string[]) {
    //    this.StartRefreshing();
    //    this.graph = {
    //        data: [{
    //            values: numData,
    //            labels: lables,
    //            type: 'pie'
    //        }
    //        ],
    //        layout: { width: 350, height: 400, title: '', showlegend: false },


    //    };
    //    this.stopRefreshing();
    //}
    LoadGraph_bk(numData: number[], lables: string[], colors: string[]) {
        this.BarChart = new (Chart as any)('barChart_' + this.ReportType, {
            type: 'bar',
            data: {
                labels: lables,
                datasets: [{
                    label: '',
                    data: numData, //[9, 7, 3, 5, 2, 10],
                    //alert(numDate);
                    backgroundColor: colors,
                    //borderColor: [
                    //    'rgba(255,99,132,1)',
                    //    'rgba(54, 162, 235, 1)',
                    //    'rgba(255, 206, 86, 1)',
                    //    'rgba(75, 192, 192, 1)',
                    //    'rgba(153, 102, 255, 1)',
                    //    'rgba(255, 159, 64, 1)'
                    //],
                    borderWidth: 1
                }]
            },
            options: {
                legend: {
                    display: false
                },
                title: {
                    text: this.ReportType,
                    display: true
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
  }
    BarChart: any = [];
    ngOnInit() {
        this.PatientActorCode = this.ActorCode;
        this.PatientCycleCode = this.CycleCode;

        //this.LoadData(this.ReportType, this.FromDate, this.ToDate);

        //this.LoadPatients();
        ///this.LoadClinics();
        //this.LoadMessages();




        // Horizontal Timeline js for user timeline
        //$.getScript('./assets/js/vertical-timeline.js');
        //



    }
    FormData: SectionData[];



    pdata: any[];// = this.data;
    listFilter: string;
    criteriaChange(value: any) {

    }
    //

    //

    showPage(page: string) {
        this.currentPage = page;
    }
    BackToProfile() {
        alert("method");
        this.router.navigate(['testnurse/dashboard']);

    }
    BackToTreatment() {
        alert("Thistrearment");
        this.router.navigate(['testnurse/ivfdashboard']);
    }
    onClick() {
        let x = document.querySelector("#psa");
        if (x) {
            x.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }
    pickUp() {
        let y = document.querySelector("#pickup");
        if (y) {
            y.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }
    ET() {
        let z = document.querySelector("#et");
        if (z) {
            z.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }
    InsuminationLog() {
        let m = document.querySelector("#IL");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }
    Grading() {
        let m = document.querySelector("#Grad");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }
    OQA() {
        let m = document.querySelector("#oqa");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }
    scans() {
        let m = document.querySelector("#scans");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
  }
    }





    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

    closeResult: string;
    // This function is used in open
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    TableView() {
        const modalRef = this.modalService.open(NgbGraphTableViewModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false

            })
        modalRef.componentInstance.TableData = this.MisReportXYControllerData;
        modalRef.componentInstance.ReportType = this.ReportType;
        modalRef.componentInstance.BranchName = this.FacilityName;
        modalRef.componentInstance.FromDate = this.FromDate;
        modalRef.componentInstance.SelectedToDate = this.ToDate;



    }
    // Open content with dark section
    //openContent() {
    //  alert('open dialog');
    //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
    //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
    //      centered: true
    //    })
    //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
    //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
    //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
    //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

    //    modalRef.result.then(x => { this.GetActorProfileController() })

    //  }
    //  else {
    //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
    //  }
    //}
    Selectedpatient() {
        this.ScanDetails = true;
    }
    BackTodashboard() {
        //this.Showivf = true;
        //this.Showpickup = false;
        this.router.navigate(['healins/ivfworkbench']);
    }
}
export class graphdata {

    public label: string;
    public data: number[];
    public fill: boolean;

    public backgroundColor: string;
    public borderColor: string;

    constructor(l: string) {
        this.label = l
    }

}
